import React, { useEffect, useState } from 'react'
import { Form, Select } from 'antd';
import { useKehukpxxListQuery } from '../../store/DianShangYeWuApi';

function ClientInvoiceSelect(props) {
    const [list,setList] = useState();
    const { data, isSuccess } = useKehukpxxListQuery(
        { khkpxx_kh_id: props.kh_id },
        { skip: !props.kh_id, refetchOnMountOrArgChange: true }
    );
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){
                const newArr = data.Result.map((item) => {
                    const {khkpxx_id,khkpxx_name,khkpxx_code,khkpxx_type_name}=item;
                    return item = {value:khkpxx_id,label:`名称：${khkpxx_name}，代码：${khkpxx_code}，发票类型：${khkpxx_type_name}`,key:khkpxx_id,khkpxx_name:khkpxx_name}      
                })
                setList(newArr)
            }
        }
    },[data,isSuccess])
    
    // 如果wrapperCol为null，说明是作为子组件使用，不包装Form.Item
    if (props.wrapperCol === null) {
        return (
            <Select
                options={list} 
                onChange={(_,f) => {
                    if(f){
                        props.onChange(f.value,f.label,)
                    }
                }}
                placeholder={props.placeholder || '请选择客户发票抬头'}
                style={props.style}
                allowClear
                onClear={props.onClear}
                disabled={props.disabled}
            />
        )
    }

    return (
        <Form.Item 
            label={props.label} 
            required={props.required}  
            style={props.formStyle}
            wrapperCol={props.wrapperCol}
            name={props.name}
        >
            <Select
                options={list} 
                onChange={(_,f) => {
                    if(f){
                        props.onChange(f.value,f.label)
                    }
                }}
                placeholder={props.placeholder || '请选择客户发票抬头'}
                style={props.style}
                allowClear
                onClear={props.onClear}
                disabled={props.disabled}
            />                        
        </Form.Item>
    )
}

export default ClientInvoiceSelect
